import IframeWindow from "./MainUI/IframeWindow.jsx";
import JoystickLook from "./MainUI/JoystickLook.jsx";
import SoundBackground from "./Utils/SoundBackground";
import JoystickMovement from "./MainUI/Joystick.jsx";
import { AnimatePresence } from "framer-motion";
import InfoWindowStoryClick from "./MainUI/InfoWindowStoryClick.jsx";
import Header from "./MainUI/Header";
import LoadingBar from "./MainUI/LoadingBar";
import ToolBar from "./MainUI/ToolBar";
import CustomLoaderProgress from "./MainUI/CustomLoaderProgress";
import CharacterSwitchUi from "./MainUI/characterSwitchUi.jsx";
import { useSnapshot } from "valtio";
import { useState, useEffect, useLayoutEffect } from "react";
import ImageGallery from "./MainUI/ImageGallery.jsx";
import DeviceToOld from "./MainUI/DeviceToOld.jsx";
import CloseButtonLowModelOrbit from "./MainUI/CloseButtonLowModelOrbit.jsx";
import OpenSketchfabButton from "./MainUI/OpenSketchfabButton.jsx";
import CloseButtonLowCharacterSwitch from "./MainUI/CloseButtonCharacterSwitch.jsx";
import CloseButtonOrbit from "./MainUI/CloseButtonOrbit.jsx";
import WaypointArrows from "./MainUI/WaypointArrows.jsx";
// Impressum wird in LoadingBar.jsx gerendert — es soll nur am Startscreen sichtbar sein.
import SalzabbauTimebar2D from "./Themes/Salzabbau/SalzabbauTimebar2D.jsx";
import salzabbauTimebarState from "./Themes/Salzabbau/states/salzabbauTimebarState.js";
import HandelswegeTimebar2D from "./Themes/Handelswege/HandelswegeTimebar2D.jsx";
import handelswegeTimebarState from "./Themes/Handelswege/states/handelswegeTimebarState.js";
import MenschenTimebar2D from "./Themes/Menschen/MenschenTimebar2D.jsx";
import menschenTimebarState from "./Themes/Menschen/states/menschenTimebarState.js";
import HolzarbeitTimebar2D from "./Themes/Holzarbeit/HolzarbeitTimebar2D.jsx";
import holzarbeitTimebarState from "./Themes/Holzarbeit/states/holzarbeitTimebarState.js";
import KlimaTimebar2D from "./Themes/Klima/KlimaTimebar2D.jsx";
import klimaTimebarState from "./Themes/Klima/states/klimaTimebarState.js";
import {
  stateWallPush,
  statePlayerSwitch,
  stateTouchCircleLook,
  stateIframeWindow,
  stateLoadingScreen,
  stateTouchCircle,
  stateOrbitLocation,
  statePlayerPositionS,
  stateInArea,
  stateMemory,
 stateEnglisch,
 stateNavigation
} from "./store.jsx";
// import Schnellreise from "./MainUI/Schnellreise.jsx";
import TeleportingScreen from "./MainUI/TeleportingScreen.jsx";

export default function UiManager({ setGravity}) {
  const [start, setStart] = useState(false);
  const snapPlayerSwitch = useSnapshot(statePlayerSwitch);
  const snapTouchCircleLook = useSnapshot(stateTouchCircleLook);
  const snapTouchCircle = useSnapshot(stateTouchCircle);
  const snapOrbitLocation = useSnapshot(stateOrbitLocation);
  const snapPlayerPositionS = useSnapshot(statePlayerPositionS);
  const snapWallPushIndex = useSnapshot(stateWallPush);
  const snapLaodingscreen = useSnapshot(stateLoadingScreen);
  const snapIframeWindow = useSnapshot(stateIframeWindow);
  const snapStateMemory = useSnapshot(stateMemory);
  const snapStateEnglisch = useSnapshot(stateEnglisch)
  const snapStateNavigation = useSnapshot(stateNavigation)
const snapInArea = useSnapshot(stateInArea)
const snapSalzabbauTimebar = useSnapshot(salzabbauTimebarState)
const snapHandelswegeTimebar = useSnapshot(handelswegeTimebarState)
const snapMenschenTimebar = useSnapshot(menschenTimebarState)
const snapHolzarbeitTimebar = useSnapshot(holzarbeitTimebarState)
const snapKlimaTimebar = useSnapshot(klimaTimebarState)


  const roomTitelArrayDe = [
    "Die Salzzeit Museen",
    "Die Holzarbeit",
    "Die Ökologie",
    "Das Salz",
    "Der Salztransport",
    "Die Kulturgeschichte",
  ];

  const roomTitelArrayEn = [
    "The Salzzeit Museums",
    "The woodwork",
    "The ecology",
    "The salt",
    "The transport of salt",
    "The cultural history",
  ];

  const roomTitelArray = snapStateEnglisch.isEnglisch ? roomTitelArrayEn : roomTitelArrayDe

  const [roomArray, setRoomArray] = useState([-1])
  const [shouldShowLoader, setShouldShowLoader] = useState(true)
  const [lastInfoWindowTimout, setLastInfoWindowTimout] =useState(false)

  const [logoExitDone, setLogoExitDone] = useState(true);
  useEffect(()=>{
console.log(logoExitDone)

  },[logoExitDone])


useEffect(() =>{
if (start){
  stateLoadingScreen.lastInfoWindowClick = true
  statePlayerPositionS.playerInput = true
  stateLoadingScreen.startPressed = true
}

}, [start])

  useEffect(() => {
    stateInArea.inArea = false;
    // stateIframeWindow.renderCanvas = true;
  }, [snapLaodingscreen.loadingScreenAnimate]);

  useEffect(() => {
    stateInArea.inArea = false;
  
    let timerId; // Declare the timerId variable outside the if block
  
    if (snapLaodingscreen.lastInfoWindowClick) {
      const delay = 1000; // Set your desired delay time in milliseconds
      timerId = setTimeout(() => {
        setLastInfoWindowTimout(true);
      }, delay);
    }
  
    return () => {
      if (timerId) {
        clearTimeout(timerId); // Clear the timeout only if timerId is defined
      }
    };
  }, [snapLaodingscreen.lastInfoWindowClick]);

  useEffect(()=>{
    // setShouldShowLoader(!roomArray.includes(snapWallPushIndex.activeThemeIndex))
    // setRoomArray(oldArray => [...oldArray, snapWallPushIndex.activeThemeIndex])
    // Check if the newActiveThemeIndex is not already in roomArray
    // Check if snapWallPushIndex.activeThemeIndex is not already in roomArray
    if (!roomArray.includes(snapWallPushIndex.activeThemeIndex)) {
      setRoomArray(oldArray => [...oldArray, snapWallPushIndex.activeThemeIndex]);
    }
  },[snapWallPushIndex.activeThemeIndex])

  useLayoutEffect(()=>{

    setShouldShowLoader(!roomArray.includes(snapWallPushIndex.activeThemeIndex))

  })




  return (
    <>
    {snapStateNavigation.isClickNavi && <TeleportingScreen></TeleportingScreen>}
    {/* <AnimatePresence key={"Schnellreise"}>
    {lastInfoWindowTimout && <Schnellreise></Schnellreise>}
    </AnimatePresence> */}
    {!snapStateNavigation.isClickNavi && <WaypointArrows></WaypointArrows>}
    {!snapStateNavigation.isClickNavi && snapSalzabbauTimebar.areaActive && <SalzabbauTimebar2D />}
    {!snapStateNavigation.isClickNavi && snapHandelswegeTimebar.areaActive && <HandelswegeTimebar2D />}
    {!snapStateNavigation.isClickNavi && snapMenschenTimebar.areaActive && <MenschenTimebar2D />}
    {!snapStateNavigation.isClickNavi && snapHolzarbeitTimebar.areaActive && <HolzarbeitTimebar2D />}
    {!snapStateNavigation.isClickNavi && snapKlimaTimebar.areaActive && <KlimaTimebar2D />}
<ImageGallery></ImageGallery>

      {lastInfoWindowTimout &&

        !snapPlayerSwitch.charSwitchClicked &&
        !snapOrbitLocation.orbitClicked && snapStateNavigation.isClickNavi && <JoystickMovement />}

      {lastInfoWindowTimout &&
        snapTouchCircleLook.JoystickLookVisible &&
        !snapTouchCircle.joystickMove &&
        !snapPlayerSwitch.charSwitchClicked &&
        !snapOrbitLocation.orbitClicked &&
        !snapPlayerPositionS.fpPlayer && snapStateNavigation.isClickNavi && <JoystickLook />}

      {snapIframeWindow.showIframe && (
        <IframeWindow
          src={snapIframeWindow.src} // Replace with your desired URL
          // onClose={stateIframeWindow.showIframe = false}
        />
      )}

      <AnimatePresence key={"Loading"}
       onExitComplete={() => {
         setLogoExitDone(true);
         // Signal für GpuPrewarm: Startscreen ist KOMPLETT weggefadet —
         // vorher darf der Prewarm nicht laufen, sonst blockiert er den
         // JS-getriebenen Fade (framer-motion) und der Screen scheint
         // kurz "aufzublinken".
         stateLoadingScreen.exitComplete = true;
       }}
       >
        {!start && (
          <LoadingBar
        
            started={start}
            onStarted={() => setStart(true) & setGravity(-1000)}
          />
        ) }
      </AnimatePresence>

      {snapStateNavigation.isClickNavi &&     <AnimatePresence key={"Toolbar"}>
        {snapLaodingscreen.lastInfoWindowClick &&
          !snapPlayerSwitch.characterUiOn && snapInArea.inArea &&  <ToolBar/>}
      </AnimatePresence>}
      <AnimatePresence key={"Header"}>
        {snapLaodingscreen.lastInfoWindowClick && snapStateNavigation.isClickNavi &&  <Header />}
        {snapPlayerSwitch.characterUiOn && snapStateNavigation.isClickNavi && (
          <CharacterSwitchUi></CharacterSwitchUi>
        )}
        {snapPlayerSwitch.characterUiOn && (  <CloseButtonLowCharacterSwitch></CloseButtonLowCharacterSwitch>  )}
      </AnimatePresence>
      {/* <AnimatePresence key={"Infowindow"}>
     {logoExitDone && <InfoWindowStoryClick/>} 
      </AnimatePresence> */}

     <DeviceToOld showDeviceToOld={snapStateMemory.deviceToOld}></DeviceToOld>

      {/* {start && <SoundBackground></SoundBackground>} */}
   {snapIframeWindow.LowModelOrbit && <CloseButtonLowModelOrbit></CloseButtonLowModelOrbit>}
    {snapIframeWindow.LowModelOrbit && <OpenSketchfabButton></OpenSketchfabButton>}
    {snapOrbitLocation.orbitClicked && <CloseButtonOrbit></CloseButtonOrbit>}
      {/* { snapWallPushIndex.activeThemeIndex != -1 && <CustomLoaderProgress
          title={roomTitelArray[snapWallPushIndex.activeThemeIndex]}
          text={ snapStateEnglisch.isEnglisch ? "Content is loading" : "Content wird geladen"}
        />} */}
{/* {   snapPlayerPositionS.homeclicked &&  <CustomLoaderProgress
          title={roomTitelArray[snapWallPushIndex.activeThemeIndex]}
          text={ snapStateEnglisch.isEnglisch ? "Content is loading" : "Content wird geladen" }
        />} */}
    </>
  );
}
